// extracted by mini-css-extract-plugin
module.exports = {"group_list_items":"group_list_items__hcZaWWV7gpA8W"};